import { Environment } from '../app/models/environment';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://mysgltest-api.scangl.com/api',
  scanBookUrl: 'https://scanbook.scangl.com/Bookings.aspx?bookingextid=',
  scanViewUrl: 'https://scanview.scangl.com/GTN/priv/to/detail.jsp?iTOID=',
  vesselSchedulesPlatformId: 6616,
  publicTrackingUrl: 'https://trackingtest.scangl.com',
  msal: {
    clientId: '75456652-e093-4f9f-9bdd-880dc6c27550',
    authority: 'https://login.scangl.com/adfs',
    postLogoutUrl: 'https://login.scangl.com/adfs/oauth2/logout'
  },
  apiConfig: {
    scopes: ['openid', 'profile']
  },
  appInsights: {
    connectionString:
      'InstrumentationKey=182dc209-cbce-4eef-8f1b-eacc82f52183;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=64ea91b1-2a72-418c-9184-442e8e613842'
  },
  menuExternalLinks: {
    scanbook: 'https://scanbook.scangl.com/MakeBooking.aspx',
    parcelexpress: 'https://express.scangl.com',
    scanview: 'https://scanview.scangl.com',
    scanrate: 'https://scanbook.scangl.com/Calculator.aspx',
    scanoms: 'https://scanoms.scangl.com/login.aspx',
    scanwms: 'https://scanwms.scangl.com',
    scancloud: 'https://scancloud.scangl.com',
    marineportal: 'https://marinelog.scangl.com',
    windward:
      'https://ofv.wnwd.com/?loginserver=https://login.microsoftonline.com/32179370-3c43-49fc-a6ec-c4525294e1b3/v2.0/'
  }
};
